import { GridColDef } from "@mui/x-data-grid-pro";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TachographDriverRow } from "../models/Tachograph";
import { TACHOGRAPH_PAGE_SIZES } from "./tachographGridDefaults";
import { I18nGrid } from "@/components/data/I18nGrid";

type Props = {
  rows: TachographDriverRow[];
  loading: boolean;
};

/** One row per driver with the deadline for the driver card. */
export function TachographDriverGrid({ rows, loading }: Props) {
  const { t } = useTranslation();

  const columns = useMemo<GridColDef<TachographDriverRow>[]>(
    () => [
      { field: "driver", headerName: t("tachograph.columns.driver"), minWidth: 260, flex: 1 },
      {
        field: "driverCardNumber",
        headerName: t("tachograph.columns.driverCardNumber"),
        minWidth: 220,
        flex: 1,
      },
      {
        field: "licensePlate",
        headerName: t("tachograph.columns.licensePlate"),
        minWidth: 180,
        flex: 0.8,
      },
      { field: "legalLimit", headerName: t("tachograph.columns.legalLimit"), minWidth: 220, flex: 1 },
      {
        field: "nextDownloadUtc",
        headerName: t("tachograph.columns.nextDownloadUtc"),
        minWidth: 220,
        flex: 1,
      },
      {
        field: "calibrationExpiryDate",
        headerName: t("tachograph.columns.calibrationExpiryDate"),
        minWidth: 220,
        flex: 1,
      },
      { field: "updateTime", headerName: t("tachograph.columns.updateTime"), width: 170 },
    ],
    [t],
  );

  return (
    <I18nGrid
      rows={rows}
      columns={columns}
      loading={loading}
      density="compact"
      disableRowSelectionOnClick
      pageSizeOptions={TACHOGRAPH_PAGE_SIZES}
      initialState={{ sorting: { sortModel: [{ field: "driver", sort: "asc" }] } }}
    />
  );
}
